import { createSlice } from "@reduxjs/toolkit";
import {
  IProductsSliceState,
  MissingProductData,
} from "@src/store/slices/products/types";

const initialState: IProductsSliceState = {
  products: {},
};

const slice = createSlice({
  name: "products",
  initialState,
  reducers: (create) => ({
    addMissingData: create.reducer<MissingProductData[]>((state, action) => {
      for (const product of action.payload) {
        state.products[product.id] = product;
      }
    }),
  }),
  selectors: {
    getMissingProducts: (state) => state.products,
  },
});

export const productsReducer = slice.reducer;

export const { addMissingData } = slice.actions;
export const { getMissingProducts } = slice.selectors;
